export const BOOKING_START_AT = new Date("2026-01-15T00:00:00+05:30");

export function isBookingOpen() {
  return new Date() >= BOOKING_START_AT;
}

export function bookingMessage() {
  return "Pre-Booking starts from 15 January 2026, 00:00 IST";
}
